<template>
  <section v-show="fragmentsLoaded" class="eptp_content">
    <div class="container">
      <ul class="breadcrumbs">
        <li>
          <a :href="homeHref">{{ $t('pages.home.title') }}</a>
        </li>
        <li>
          <a :href="$url($t('pages.bnkCatalogue.url'))">{{ $t('pages.bnkCatalogue.title') }}</a>
        </li>
      </ul>

      <BaseGlobalAlert />

      <h1 class="pb-4">{{ $t('pages.bnkCatalogue.title') }}</h1>

      <div class="full-width">
        <div v-for="(bnk, index) in bnkList" :key="bnk.id" class="pb-2">
          <h4>{{ bnk.name }}</h4>
          <div class="d-flex justify-space-between flex-column flex-sm-row">
            <p class="pr-sm-4">{{ bnk.description }}</p>
            <div>
              <a
                href="#"
                :class="{ 'btn-loading': requestPending }"
                class="btn btn-regular"
                @click.prevent="initBnkRequest(bnk)"
              >
                {{ $t('pages.bnkCatalogue.actions.fillRequest') }}
              </a>
            </div>
          </div>
          <hr v-if="index < bnkList.length - 1" class="display-none-sm" />
        </div>
      </div>
    </div>

    <ImportantMessagesModal
      :loading="loadingImportantMessage"
      :message="displayedImportantMessage"
      @read="markImportantMessageAsRead"
    />
  </section>
</template>

<script>
import pageMixin from '../../mixins/page.mixin';
import BaseGlobalAlert from '../../components/base/BaseGlobalAlert';
import pubService from '@/services/pub.service';
import profileService from '@/services/profile.service';

export default {
  name: 'BnkCatalogue',

  components: { BaseGlobalAlert },

  mixins: [pageMixin],

  data() {
    return {
      loadingBnk: false,
      bnkList: [],
      requestPending: false,
    };
  },

  created() {
    document.title = `EPTP - ${this.$t('pages.bnkCatalogue.title')}`;
    this.getBnkList();
  },

  mounted() {
    this.setupPage();
  },

  methods: {
    getBnkList() {
      this.loadingBnk = true;
      pubService
        .getBnkList()
        .then((res) => {
          this.bnkList = res.data.bnk;
        })
        .finally(() => {
          this.loadingBnk = false;
        });
    },

    initBnkRequest(bnk) {
      if (this.requestPending) {
        return;
      }
      this.requestPending = true;
      profileService
        .initBnkRequest()
        .then((res) => {
          window.location.href = this.$url(
            `${this.$t('pages.bnkRequest.url')}?id=${res.data.orderId}&bnkId=${bnk.id}&mode=edit`
          );
        })
        .catch((err) => {
          this.requestPending = false;
          throw err;
        });
    },
  },
};
</script>

<style>
@import '../../../assets/css/style.min.css';
@import '../../assets/index.css';
</style>
